'use strict';

import _ from 'underscore';
import config from '../js/config';
import utilities from '../js/utilities';
import { hybrisMakeRequest } from '../utilities/makeRequest';
import { EnableArrowReel as EnableArrowReelFeature } from '../utilities/featureFlags';
import cacheCookieHelper from '../components/CacheCookieHelper/CacheCookieHelper';
import cookies from 'js-cookie';
import SwaCartAPI from './SwaCartApi';
import * as globalisation from '../utilities/globalisation';
import mediator from '../js/mediator';
import userService from '../services/CartUserService';
let featureFlags = require('../utilities/featureFlags');
export default class HybrisCartAPI extends SwaCartAPI {
  constructor() {
    super();
    this.retryCount = 0;
  }

  init() {
    this._getProductUrl = _.template(config.urls.cart.product);
    if (featureFlags.EnableEUCFieldsPh2.isEnabled()) {
      this.isProfileRedirect();
    }
  }

  isProfileRedirect() {
    //when cart summary is opened in another tab from ProfileUpdate redirect back
    let accessToken = cookies.get(config.cookies.accessToken);
    if (accessToken && window.location.href.indexOf('profileupdate') <= 0) {
      let referrer = sessionStorage.getItem('referrer');
      //new tab
      if (cookies.get('isOnProfileUpdate') && accessToken && !referrer && window.location.href.indexOf('profileupdate') < 0) {
        //user should logout
        this.userLogOut();
      } else {
        //copy paste cartsummary url in ProfileUpdate Page in login mode
        let b2bUserData = utilities.sessionStorageLoad('b2busers');
        if (b2bUserData && !b2bUserData.eucCustomerInfo || (b2bUserData && b2bUserData.eucCustomerInfo && b2bUserData.eucCustomerInfo.eucExpired)) {
          //user should logout
          this.userLogOut();
        }
      }
    }    
    //logout mode profile update page should not be accessible
    else if (!accessToken) {
      if (window.location.href.indexOf('profileupdate') > 0) {
        window.location.href = config.urls.loginPage;
      }
    } else {
      // When profile update page refreshed, do not logout else on other page logout
      const isRedirect = sessionStorage.getItem('isOnProfileUpdate');
      if (isRedirect && (window.location.href.indexOf('profileupdate') < 0)) {
        this.userLogOut();
      }
    }
  }

  isPromoApplied(cart) {
    if (!!(cart && cart.appliedVouchers && cart.appliedVouchers[0].voucherCode)) {
      this.removePromoCode(cart.appliedVouchers[0].voucherCode)
        .then((cartContent) => {
          cartContent = this._fromData(cartContent);
          const errors = cartContent.errors;
          this.createReels(cartContent);
          this._addAdditionalCartProperties(cartContent);
          cartContent.errors = errors;
          utilities.sessionStorageSave('cart', cartContent);
          mediator.trigger(config.events.cart.updated, cartContent);
        });
    }
  }

  userLogOut() {
    if (cookies.get(config.cookies.csrSignedInAsCustomer)) {
      cookies.remove(config.cookies.csrSignedInAsCustomer);
    }
    userService.siteLogout().then((data) => {
      if (featureFlags.EnableHybrisIntegration.isEnabled()) {
        console.log('Got trigger ln. 110 - bio-arrow - remove cartida AccountLinksView');
        cookies.remove(config.hybris.anonymousid);
        cookies.remove(config.cookies.accessToken);
        console.log('Got trigger ln. 112 - bio-arrow - Got Deleted cartida from AccountLinksView.js');
        utilities.sessionStorageRemove('b2busers', '');
        utilities.sessionStorageRemove('cart', '');
      }
      userService.crossSiteLogout(data);
      if (window.location.href.indexOf('/account') > 0) {
        window.location.href = config.urls.loginPage;
      }
      cookies.remove('isOnProfileUpdate');
      sessionStorage.removeItem('isOnProfileUpdate');
      utilities.sessionStorageRemove(config.sessionVariables.header.personalInfo);
      location.reload();
    });
  }

  /**
   * get cart content
   */
  getContents(customReel = true, localStorage = false) {
    // Remove goToCartSummary session flag to avoid redirect in ArrowPerks opt in MyAccount
    const redirectCart = utilities.sessionStorageLoad('goToCartSummary', null);
    if (redirectCart && window.location.href.indexOf('account') === -1) {
      utilities.sessionStorageRemove('goToCartSummary');
    }
    return this.getCartId()
      .then((cartId) => {
        if (cartId) {
          if (localStorage) {
            return this.getLocalStorageCart(customReel);
          } else {
            return this.getContentsById(cartId, customReel, true);
          }
        } else {
          // do not create new cart or make api call if there is no cart id
          // just return a mocked empty cart.
          const json = this._fromData(this.getEmptyCartContent());
          this._addAdditionalCartProperties(json);
          return Promise.resolve(json);
        }
      })
      .catch((err) => {
        let p = null;
        if (this.retryCount < 1) {
          cookies.set(config.hybris.anonymousid, '');
          if (cacheCookieHelper) {
            cacheCookieHelper.setCacheCookie();
          }
          this.retryCount++;
          p = this.getContents(true, false);
        } else {
          this.retryCount = 0;
          p = Promise.reject(err);
        }
        return p;
      });
  }

  _addAdditionalCartProperties(json) {
    // Update the item count
    json.cartItemCount = json.entries.length;
    json.miniCartItemCount = json.cartItemCount > config.cart.maxMiniCartItemCount ? config.cart.maxMiniCartItemCount : json.cartItemCount;

    // Add cart URL
    json.viewCartUrl = config.urls.cart.cart;

    // Remove un-used properties to store less in local storage
    delete json.additionalFee;
    delete json.leadTime;
    delete json.errors;

    // Add Handling Fee for Small Cart
    if (json && json.feeEntries) {
      let handlingFeeItem = json.feeEntries.filter(item => {
        return item.fee.code === config.hybris.handlingFee;
      });
      if (handlingFeeItem && handlingFeeItem.length) {
        json.handlingFee = handlingFeeItem[0];
        if (config.cartPromotionSettings && config.cartPromotionSettings.minPurchaseForFreeShipping) {
          json.minPurchase = utilities.applyExchangeRate(config.cartPromotionSettings.minPurchaseForFreeShipping);
          json.minPurchase = globalisation.formatCurrency(json.minPurchase, 2, 2);
        }
        delete json.feeEntries;
      }
    }

    // Exchange rate
    json.total = this._applyExchangeRate(json.total);
    json.subtotal = this._applyExchangeRate(json.subtotal);

    let languageCode = cookies.get(config.cookies.arrowLanguage);

    // For each product
    json.entries.forEach((entry) => {
      // Add product URL
      entry.productUrl = '/' + languageCode + this._getProductUrl(entry);

      // Fix product image when it does not exist
      if (!entry.catalogSmallImageURL || entry.catalogSmallImageURL.lastIndexOf('not_valid_image.jpg') !== -1) {
        entry.catalogSmallImageURL = config.urls.cart.defaultImage;
      }

      // Fix product image when it does not exist
      if (!entry.catalogSmallImageURL || entry.catalogSmallImageURL.lastIndexOf('not_valid_image.jpg') !== -1) {
        entry.catalogSmallImageURL = config.urls.cart.defaultImage;
      }

      // Fix HTTPS
      entry.catalogSmallImageURL = entry.catalogSmallImageURL.replace('http://', '//');

      // Exchange rate
      entry.itemTotal = this._applyExchangeRate(entry.itemTotal);
      entry.unitPrice = utilities.applyExchangeRate(entry.unitPrice || 0);
      if (entry.listPriceTotalValue && entry.priceGroupPriceTotalValue) {

        entry.listPriceTotalValue = this._applyExchangeRate(entry.listPriceTotalValue);
        entry.priceGroupPriceTotalValue = this._applyExchangeRate(entry.priceGroupPriceTotalValue);
        entry.listPriceValue = utilities.applyExchangeRate(entry.listPriceValue);
        entry.priceGroupPriceValue = utilities.applyExchangeRate(entry.priceGroupPriceValue);

      }
      if (entry.bundlePriceTotal) {
        entry.bundlePriceTotalValue = utilities.applyExchangeRate(entry.bundlePriceTotal.value);
      }

      // Add date code for display
      if (entry.catalogDateCode) {
        entry.dateCode = `${entry.catalogDateCode.toString()}`;
      } else {
        entry.dateCode = globalisation.pluraliseAndTranslate('common', 'na');
      }

      // Check for items that are less than 1 cent
      if (json.subtotal === '0.00') {
        json.subtotal = (parseFloat(json.subtotal) + parseFloat(entry.itemTotal)).toString();
      }
    });
  }

  /**
   * Add a product to the cart and sync local state
   *
   * @param {AddedProduct[]} addedProducts
   * @returns {Promise}
   */
  addProductToCart(addedProducts) {
    return this.addToCart(addedProducts, config.locale.currencyIsoCode)
      .then(cartContents => {
        cartContents.total = cartContents.subtotal;
        this.cartState = cartContents;
        utilities.sessionStorageSave('cart', cartContents);
        return cartContents;
      })
      .catch((err) => {
        err.addedProducts = addedProducts;
        throw err;
      });
  }

  getCartProductRequestItems(product) {
    let jsonProduct = {};
    let sourcePartId = product.model.sourcePartId;
    if (EnableArrowReelFeature.isEnabled() && product.model.isArrowReel) {
      sourcePartId = sourcePartId.replace('-AR', '');
      jsonProduct.addToCartOptions = config.hybris.customReel;
    }
    jsonProduct.itemID = sourcePartId;
    jsonProduct.quantity = product.quantity;
    jsonProduct.sourceCode = product.model.sourceCode;
    if (product.model.productDetails && product.model.productDetails.partSeo) {
      jsonProduct.productSeo = product.model.productDetails.partSeo
    } else if (product.model.partNumber) {
      jsonProduct.productSeo = toSeoUrl(product.model.partNumber);
    }
    jsonProduct.manufacturerSeo = product.model.productDetails ? product.model.productDetails.manufacturerSeo : product.model.manufacturerSeo;
    return jsonProduct;
  }

  /**
   * add products to cart
   * @param {*} addedProducts
   * @param {*} currency
   */
  addToCart(addedProducts, currency) {
    return this.getCartIdWithCreate()
      .then((cartId) => {
        const data = {
          'currency': currency || 'USD',
          'items': _.map(addedProducts, (product) => {
            return this.getCartProductRequestItems(product);
          })
        };
        const requestOptions = {
          url: `${this.getCartUrl()}/${cartId}/entries`,
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          method: 'POST',
          async: false,
          data: JSON.stringify(data)
        };
        return hybrisMakeRequest(requestOptions)
          .run()
          .then((request) => {
            let json = request.response;
            json.addedProducts = addedProducts;
            json = this._fromData(json);
            if (json.childEntriesMap) {
              json.childEntriesMap = json.childEntriesMap.filter(entry => { return this.removeAdditionalChildEntry(json.childEntriesMap, entry); });
            }
            //FIXME: missing catalogPartNo
            this.createReels(json);
            // Add the original product data
            this._addAdditionalCartProperties(json);
            return json;
          })
          .catch((err) => {
            err.addedProducts = addedProducts;
            throw err;
          });
      });
  }

  /**
   * This method converts the backend item model to UI cart item model
   * @param {*} data
   */
  _fromData(data) {
    const result = {
      ...data
    };
    result.entries = (result.entries || []).map((item) => {
      item.unitPrice = item.basePrice.value;
      item.itemTotal = item.totalPrice.value;
      if (item && item.listPriceTotal && item.priceGroupPriceTotal
        && item.listPrice && item.priceGroupPrice) {
        item.listPriceTotalValue = item.listPriceTotal.value;
        item.priceGroupPriceTotalValue = item.priceGroupPriceTotal.value;
        item.listPriceValue = item.listPrice.value;
        item.priceGroupPriceValue = item.priceGroupPrice.value;
      }
      item.rohsCompliant = item.rohsCompliant && ((item.rohsCompliant === 'COMPL') || (item.rohsCompliant === true));
      /** Note: In order  to support both hybris and existing server web app, VendorItemNo has been used as entry number key for hybris.
                This needs to be refactored as part of front end rearchitecture.
      */
      item.vendorItemNo = item.entryNumber;
      item.ipn = item.customerPartNo;
      item.catalogPartNo = item.catalogSourcePartId;
      return item;
    });
    result.subtotal = result.subTotal ? result.subTotal.value : result.totalPrice.value;
    return result;
  }

  /**
   * creat cart
   */
  createCart() {
    return hybrisMakeRequest({
      url: this.getCartUrl(),
      dataType: 'json',
      method: 'POST',
      async: false
    }).run().then(
      (request) => {
        let json = request.response;
        return json;
      })
      .catch((err) => {
        cookies.remove(config.cookies.arrowFed, { domain: config.cookies.domain });
        cookies.remove(config.cookies.accessToken, { domain: config.cookies.domain });
        throw err;
      });
  }

  removeAdditionalChildEntry(childEntries, currentEntry) {
    var childPart = childEntries.filter(childEntry => childEntry.value && childEntry.value.includes(currentEntry.key));
    return childPart.length ? false : true;
  }

  /**
   * get cart content by cart id
   * @param {*} cartId
   * @param customReel flag to create custom reels
   * @param callAPI flag to force call to the API
   */
  getContentsById(cartId, customReel = true, callAPI = false) {
    const currentCart = utilities.sessionStorageLoad('cart');
    if (currentCart && !callAPI) {
      return Promise.resolve(currentCart);
    } else {
      let langParam = cookies.get(config.cookies.arrowLanguage);
      const options = {
        url: `${this.getCartUrl()}/${cartId}?fields=FULL` + (this.validate ? '&validate=true' : '') + (this.validate ? '&lang=' + langParam : ''),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        method: 'GET',
        async: false,
        handleErrorLocally: true
      };

      return hybrisMakeRequest(options)
        .run()
        .then(
          (request) => {
            let json = request.response;
            json = this._fromData(json);
            if (json.childEntriesMap) {
              json.childEntriesMap = json.childEntriesMap.filter(entry => { return this.removeAdditionalChildEntry(json.childEntriesMap, entry); });
            }
            const errors = json.errors;
            if (customReel) {
              this.createReels(json);
            }
            this._addAdditionalCartProperties(json);
            json.errors = errors;
            this.isPromoApplied(json);
            return json;
          },
          (error) => {
            return Promise.reject(error);
          });
    }
  }



  /**
   * get the cart id
   */
  getCartId() {
    let userId = this.getUser();
    if (userId === config.hybris.anonymous) {
      let cartId = cookies.get(config.hybris.anonymousid);
      if (cartId) {
        return Promise.resolve(cartId);
      } else {
        return Promise.resolve(null);
      }
    } else {
      return this.getCartIdAuthenticated();
    }
  }


  /**
   * get the cart id
   */
  getCartIdWithCreate() {
    let userId = this.getUser();
    if (userId === config.hybris.anonymous) {
      return this.getCartIdAnonymous()
    } else {
      return this.getCartIdAuthenticated();
    }
  }

  /**
   * get the cart id of authenticated user
   */
  getCartAuthenticated() {
    return this.getContentsById(config.hybris.current, true, true)
      .then((response) => {
        if (response && response.code) {
          return response;
        } else {
          return Promise.reject(response);
        }
      })
      .catch(() => {
        return this.createCart();
      });

  }

  /**
   * get the cart id of authenticated user
   */
  getCartIdAuthenticated() {
    return Promise.resolve('current');
  }

  /**
   * get the cart id of anonymous user
   */
  getCartIdAnonymous() {
    let cartId = cookies.get(config.hybris.anonymousid);
    if (cartId) {
      return Promise.resolve(cartId);
    } else {
      return this.createCart().then((response) => {
        cartId = response.guid;
        cookies.set(config.hybris.anonymousid, cartId, {
          domain: window.location.hostname,
          expires: config.hybris.cartExpiration
        });
        if (cacheCookieHelper) {
          cacheCookieHelper.setCacheCookie();
        }
        return cartId;
      });
    }
  }

  /*
   * determine anonymous of login user
   */
  getUser() {
    // use arrowFed instead of accesstoken to determine the url because if accesstoken is missing
    // arrowfed can be use it refresh the token
    let arrowFed = cookies.get(config.cookies.arrowFed);
    if (arrowFed) {
      return config.hybris.current;
    } else {
      return config.hybris.anonymous;
    }
  }

  /**
   * get the cart url
   */
  getCartUrl() {
    return config.hybris.baseUrl + 'users/' + this.getUser() + '/carts';
  }

  getReviewYourKitUrl(cartCode, entryGroupCode) {
    let langParam = cookies.get(config.cookies.arrowLanguage);
    let options;
    if (this.getUser() === 'current') {
      options = {
        url: config.hybris.baseUrl + 'users/' + this.getUser() + '/carts/' + cartCode + '/bundle/' + entryGroupCode + '?lang=' + langParam + '&customerCurrency=' + config.locale.currencyIsoCode + '&fields=FULL',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        method: 'GET',
        async: false,
        handleErrorLocally: true
      };
    }
    else {
      let cartId = cookies.get(config.hybris.anonymousid);
      options = {
        url: config.hybris.baseUrl + 'users/' + this.getUser() + '/carts/' + cartId + '/bundle/' + entryGroupCode + '?lang=' + langParam + '&customerCurrency=' + config.locale.currencyIsoCode + '&fields=FULL',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        method: 'GET',
        async: false,
        handleErrorLocally: true
      };
    }

    return hybrisMakeRequest(options)
      .run()
      .then(
        (request) => {
          let json = request.response;
          return json;
        },
        (error) => {
          return Promise.reject(error);
        });
  }

  getLoyaltyInfo() {
    const langParam = cookies.get(config.cookies.arrowLanguage);
    const options = {
      url: `${config.masterDataMicroServicesSettings.baseUrl}pricegroups?lan=${langParam}`,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      method: 'GET',
      async: false,
      handleErrorLocally: true
    };

    return hybrisMakeRequest(options)
      .run()
      .then(
        (request) => {
          let json = request.response;
          return json;
        },
        (error) => {
          return Promise.reject(error);
        });
  }

  getLoyaltyUser() {
    const options = {
      url: `${config.hybris.baseUrl}b2busers?fields=FULL`,
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      method: 'GET',
      async: false,
      retryOptions: {
        enabled: true,
        attempts: 2
      },
      handleErrorLocally: true
    };

    return hybrisMakeRequest(options)
      .run()
      .then(
        (request) => {
          let json = request.response;
          return json;
        },
        (error) => {
          return Promise.reject(error);
        });
  }

  removePromoCode(promoCode) {
    return this.getCartIdWithCreate()
      .then((cartId) => {
        const requestOptions = {
          url: `${this.getCartUrl()}/${cartId}/vouchers/${promoCode}`,
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          method: 'DELETE',
          async: false
        };
        return hybrisMakeRequest(requestOptions)
          .run().then((response) => {
            let cartContent = response.response;
            return cartContent;
          })
      });
  }

  /**
   * This method removes the cart from Hybris backend system
   */
  removeCart() {
    return this.getCartIdWithCreate()
      .then((cartId) => {
        const requestOptions = {
          url: `${this.getCartUrl()}/${cartId}`,
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          method: 'DELETE',
          async: false
        };
        return hybrisMakeRequest(requestOptions)
          .run().then((response) => {
            let cartContent = response.response;
            if (cartContent && cartContent.guid) {
              this.cartId = cartContent.guid;
              cookies.set(config.hybris.anonymousid, cartContent.guid);
              if (cacheCookieHelper) {
                cacheCookieHelper.setCacheCookie();
              }
            } else {
              this.cartId = '';
            }
            return cartContent;
          })
      });

  }

  /**
   * Remove items from the cart
   * @param {array} products - An array of products to remove.
   * @returns {Promise<RequestPipeline>}
   */
  removeFromCart(products) {
    /** Note: In order  to support both hybris and existing server web app, VendorItemNo has been used as entry number key for hybris.
          This needs to be refactored as part of front end rearchitecture.
    */
    return this.getCartIdWithCreate()
      .then((cartId) => {
        this._removeCartAnalytics(products);
        /** As part of ARW-36048, it is confirmed by commerce team to use only entryNumber */
        const requestOptions = {
          url: `${this.getCartUrl()}/${cartId}/entries/${products[0].entryNumber}`,
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          method: 'DELETE',
          async: false
        };
        return hybrisMakeRequest(requestOptions)
          .run()
          .then((request) => {
            let json = request.response;
            json = this._fromData(json);
            if (json.childEntriesMap) {
              json.childEntriesMap = json.childEntriesMap.filter(entry => { return this.removeAdditionalChildEntry(json.childEntriesMap, entry); });
            }
            this.createReels(json);
            this._addAdditionalCartProperties(json);
            return json;
          })
          .catch((err) => {
            throw err;
          });
      });
  }

  /**
   * Updates the cart entries
   * @param {*} args
   */
  updateCartEntry(args) {
    /** Note: In order  to support both hybris and existing server web app, VendorItemNo has been used as entry number key for hybris.
              This needs to be refactored as part of front end rearchitecture.
      */
    return this.getCartIdWithCreate()
      .then((cartId) => {
        this._removeCartAnalyticsOnUpdate(args);
        let data;
        if (args.product && args.product.reelDetails) {
          data = {
            quantity: args.quantity,
            customerPartNo: args.ipn,
            addToCartOptions: config.hybris.customReel
          };
        } else {
          data = {
            quantity: args.quantity,
            customerPartNo: args.ipn
          };
        }
        const requestOptions = {
          url: `${this.getCartUrl()}/${cartId}/entries/${args.product.entryNumber}`,
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          method: 'PATCH',
          async: false,
          data: JSON.stringify(data)
        };

        return hybrisMakeRequest(requestOptions)
          .run()
          .then((request) => {
            let json = request.response;
            json = this._fromData(json);
            if (json.childEntriesMap) {
              json.childEntriesMap = json.childEntriesMap.filter(entry => { return this.removeAdditionalChildEntry(json.childEntriesMap, entry); });
            }
            this.createReels(json);
            this._addAdditionalCartProperties(json);
            return json;
          })
          .catch((err) => {
            throw err;
          });
      });
  }

  updateEntries(args, updateEntryValue) {
    return this.getCartIdWithCreate()
      .then((cartId) => {
        this._removeCartAnalyticsOnUpdate(args);
        let data;
        if ((args.product && args.product.reelDetails) ||
          (args.product && args.product.model && args.product.model.isArrowReel)) {
          data = {
            quantity: args.quantity,
            customerPartNo: args.ipn,
            addToCartOptions: config.hybris.customReel
          };
        } else {
          data = {
            quantity: args.quantity,
            customerPartNo: args.ipn
          };
        }
        const requestOptions = {
          url: `${this.getCartUrl()}/${cartId}/entries/${updateEntryValue}`,
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          method: 'PATCH',
          async: false,
          data: JSON.stringify(data)
        };

        return hybrisMakeRequest(requestOptions)
          .run()
          .then((request) => {
            let json = request.response;
            json = this._fromData(json);
            if (json.childEntriesMap) {
              json.childEntriesMap = json.childEntriesMap.filter(entry => { return this.removeAdditionalChildEntry(json.childEntriesMap, entry); });
            }
            this.createReels(json);
            this._addAdditionalCartProperties(json);
            return json;
          })
          .catch((err) => {
            throw err;
          });
      });
  }

  removeElementFromCart(product) {
    return this.getCartIdWithCreate()
      .then((cartId) => {
        const requestOptions = {
          url: `${this.getCartUrl()}/${cartId}/entries/${product.catalogSourcePartId}`,
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
          method: 'DELETE',
          async: false
        };
        return hybrisMakeRequest(requestOptions)
          .run();
      });
  }

  /**
   * merge cart
   */
  mergeCart() {
    return this.getCartAuthenticated()
      .then((response) => {
        const cartId = response.guid;
        const oldCartId = cookies.get(config.hybris.anonymousid);
        return this.mergeCartApi(cartId, oldCartId)
          .then(() => {
            cookies.remove(config.hybris.anonymousid);
            console.log('Got trigger ln. 742 - bio-arrow - Got remove cartida from HybrisCartAPI.js');
          });
      });
  }

  /**
   * merge cart api
   */
  mergeCartApi(cartId, oldCartId) {
    const data = { toMergeCartGuid: cartId, oldCartId };
    const requestOptions = {
      url: `${this.getCartUrl()}`,
      dataType: 'json',
      method: 'POST',
      async: false,
      data: data
    };
    return hybrisMakeRequest(requestOptions)
      .run()
      .catch((err) => {
        cookies.remove(config.cookies.arrowFed, { domain: config.cookies.domain });
        cookies.remove(config.cookies.accessToken, { domain: config.cookies.domain });
        throw err;
      });
  }

  createReels(json) {
    if (json.childEntriesMap && json.childEntriesMap.length) {
      const tempCartEntries = [];
      json.customEntriesMap = json.entries;
      json.childEntriesMap.forEach((entriesMap) => {
        const [cartEntry] = json.entries.filter(this.createFieldMatchPredicate('entryNumber', [entriesMap.key]));
        if (cartEntry && entriesMap.value && entriesMap.value.length) {
          const cartChildEntries = json.entries.filter(this.createFieldMatchPredicate('entryNumber', entriesMap.value));
          [cartEntry.reelDetails] = cartChildEntries.filter(this.createServiceTypedMatchPredicate(config.hybris.arrowReelFee));
        }
        if (cartEntry) {
          tempCartEntries.push(cartEntry);
        }
      });
      json.entries = tempCartEntries;
    }
    json.entries.forEach((entries) => {
      if (entries && entries.packaging) {
        entries.packaging.toUpperCase();
      }
    });
  }

  createFieldMatchPredicate(fieldName, fieldValues) {
    return function (item) {
      const index = fieldValues.findIndex((value) => {
        return value === item[fieldName];
      });
      return index >= 0;
    };
  }

  createServiceTypedMatchPredicate(value) {
    return function (item) {
      return item.product && (item.product.serviceType === value);
    };
  }

  getLocalStorageCart(customReel) {
    let currentCart = utilities.sessionStorageLoad('cart');
    currentCart = this._fromData(currentCart);
    const errors = currentCart.errors;
    if (customReel) {
      this.createReels(currentCart);
    }
    this._addAdditionalCartProperties(currentCart);
    currentCart.errors = errors;
    return Promise.resolve(currentCart);

  }

  /**
   * empty cart content
   * part of optimize ARW-18438 to reduce api calls
   * an empty cart content is use to put the cart in a valid consistent state.
   */
  getEmptyCartContent() {
    return {
      'type': 'cartWsDTO',
      'calculated': false,
      'code': 'EMPTY_CODE',
      'deliveryCost': {
        'currencyIso': 'USD',
        'displayValue': 0.0,
        'formattedDisplayValue': '$0.00',
        'formattedValue': '$0.00000',
        'priceType': 'BUY',
        'value': 0.0
      },
      'guid': 'EMPTY_GUID',
      'net': true,
      'orderDiscounts': {
        'currencyIso': 'USD',
        'displayValue': 0.0,
        'formattedDisplayValue': '$0.00',
        'formattedValue': '$0.00000',
        'priceType': 'BUY',
        'value': 0.0
      },
      'productDiscounts': {
        'currencyIso': 'USD',
        'displayValue': 0.0,
        'formattedDisplayValue': '$0.00',
        'formattedValue': '$0.00000',
        'priceType': 'BUY',
        'value': 0.0
      },
      'site': 'arrow',
      'store': 'arrow',
      'subTotal': {
        'currencyIso': 'USD',
        'displayValue': 0.0,
        'formattedDisplayValue': '$0.00',
        'formattedValue': '$0.00000',
        'priceType': 'BUY',
        'value': 0.0
      },
      'subtotalWithTariff': {
        'currencyIso': 'USD',
        'displayValue': 0.0,
        'formattedDisplayValue': '$0.00',
        'formattedValue': '$0.00000',
        'priceType': 'BUY',
        'value': 0.0
      },
      'subtotalWithoutTariff': {
        'currencyIso': 'USD',
        'displayValue': 0.0,
        'formattedDisplayValue': '$0.00',
        'formattedValue': '$0.00000',
        'priceType': 'BUY',
        'value': 0.0
      },
      'totalDiscounts': {
        'currencyIso': 'USD',
        'displayValue': 0.0,
        'formattedDisplayValue': '$0.00',
        'formattedValue': '$0.00000',
        'priceType': 'BUY',
        'value': 0.0
      },
      'totalItems': 0,
      'totalPrice': {
        'currencyIso': 'USD',
        'displayValue': 0.0,
        'formattedDisplayValue': '$0.00',
        'formattedValue': '$0.00000',
        'priceType': 'BUY',
        'value': 0.0
      },
      'totalPriceWithTax': {
        'currencyIso': 'USD',
        'displayValue': 0.0,
        'formattedDisplayValue': '$0.00',
        'formattedValue': '$0.00000',
        'priceType': 'BUY',
        'value': 0.0
      },
      'totalTariff': {
        'currencyIso': 'USD',
        'displayValue': 0.0,
        'formattedDisplayValue': '$0.00',
        'formattedValue': '$0.00000',
        'priceType': 'BUY',
        'value': 0.0
      },
      'totalTax': {
        'currencyIso': 'USD',
        'displayValue': 0.0,
        'formattedDisplayValue': '$0.00',
        'formattedValue': '$0.00000',
        'priceType': 'BUY',
        'value': 0.0
      },
      'totalUnitCount': 0
    };
  }

}

/*
 * FIXME:
 * this method convert word to seo equivalent, this one is tempory fix to
 * produce productSeo and manufactureSeo that is need for the hybris add to cart api
 * those field not be need in a few weeks and this function can be remove then
 */
function toSeoUrl(url) {
  return url.toString() // Convert to string
    .replace(/[\u0300-\u036f]/g, '') // Remove illegal characters
    .replace(/\s+/g, '-') // Change whitespace to dashes
    .toLowerCase() // Change to lowercase
    .replace(/&/g, '-and-') // Replace ampersand
    .replace(/[^a-z0-9\-]/g, '') // Remove anything that is not a letter, number or dash
    .replace(/-+/g, '-') // Remove duplicate dashes
    .replace(/^-*/, '') // Remove starting dashes
    .replace(/-*$/, ''); // Remove trailing dashes
}



// WEBPACK FOOTER //
// ./assets/services/HybrisCartAPI.js